import React, { useContext } from 'react';
import { Button } from 'antd';

import ApprovalCreateDialog, {
  REQUEST_APPROVAL_ACTIVITY_ID,
} from '@totem/components/ticketing/details/dialogs/approvalCreateDialog';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { isNotNull } from '@totem/utilities/common';

const ApprovalCreateButton = () => {
  const { onAction, activityConfiguration, action } = useContext(TicketContext);

  const hasPermissions = () => {
    const activityConfig = activityConfiguration.find(
      (activity) => activity.id === REQUEST_APPROVAL_ACTIVITY_ID,
    );

    return isNotNull(activityConfig);
  };

  return (
    <>
      {hasPermissions() && (
        <>
          <Button
            type="primary"
            onClick={() => onAction('show-approval-create', '')}
          >
            Add Approval
          </Button>
          {action === 'show-approval-create' && <ApprovalCreateDialog />}
        </>
      )}
    </>
  );
};

export default ApprovalCreateButton;
